export const RIGHTS = {
  DEFAULT: 0b0, //                    0   : Aucun droit spécifique
  SUPER_ADMIN: 0b1, //                1   : Le droit le plus élevé, inclut tous les autres droits
  CPI_GLOBAL: 0b10, //                2   : Droits spécifiques de CPI_GLOBAL
  CHECKPOINT: 0b100, //               4   : Droits spécifiques de CHECKPOINT
  ADMIN: 0b1000, //                   8   : Accès aux modifications hors finance et stock
  READER: 0b1_0000, //                 16  : Accès au BO en lecture seule hors finance et stock
  ACCOUNTING_ADMIN: 0b10_0000, //      32  : Accès aux modifications financières
  ACCOUNTING_READER: 0b100_0000, //    64  : Accès aux finances en lecture seule
  STOCK_ADMIN: 0b1000_0000, //         128 : Accès aux modifications de stock
  STOCK_READER: 0b1_0000_0000, //       256 : Accès au stock en lecture seule
  QUALITY: 0b10_0000_0000, //           512 : Accès aux droits qualité
  STORE_OPERATOR: 0b100_0000_0000, //   1024: Accéder au magasin en tant que gestionnaire
  SUPPORT_OPERATOR: 0b1000_0000_0000, //         2048: Opérateur sur la plateforme

  // --------------------------------------------------------------------- //
  //                        Foncier & travaux (Immobilier)                 //
  // --------------------------------------------------------------------- //
  REAL_ESTATE_READER: 0b1_0000_0000_0000, //          4096 : Accès lecture foncier (hors finance)
  REAL_ESTATE_ADMIN: 0b10_0000_0000_0000, //          8192 : Gestion projets & tâches foncier
  REAL_ESTATE_FINANCE_READER: 0b100_0000_0000_0000, //  16384: Consultation finances foncier
  REAL_ESTATE_FINANCE_ADMIN: 0b1000_0000_0000_0000, //  32768: Gestion finances foncier

  // --------------------------------------------------------------------- //
  //                        HR (Human Resources)                           //
  // --------------------------------------------------------------------- //
  STORE_CLOCKING: 0b1_0000_0000_0000_0000, //          65536 : Accès au pointage de boutiques
}

export type Right = keyof typeof RIGHTS

export const RIGHTS_LABELS: { [K in Right]: string } = {
  ACCOUNTING_ADMIN: 'Modification Comptabilité',
  ACCOUNTING_READER: 'Lecture comptabilité',
  ADMIN: 'Modification BO',
  CHECKPOINT: 'Checkpoint',
  CPI_GLOBAL: 'CPI Global',
  DEFAULT: 'default',
  QUALITY: 'Qualité & blocage',
  READER: 'Lecture BO',
  REAL_ESTATE_ADMIN: 'Foncier & travaux - Gestion',
  REAL_ESTATE_FINANCE_ADMIN: 'Foncier & travaux - Finance (gestion)',
  REAL_ESTATE_FINANCE_READER: 'Foncier & travaux - Finance (lecture)',
  REAL_ESTATE_READER: 'Foncier & travaux - Lecture',
  STOCK_ADMIN: 'Modification Stock',
  STOCK_READER: 'Lecture stock',
  STORE_OPERATOR: 'Gestionnaire de magasin',
  SUPER_ADMIN: 'Super admin',
  SUPPORT_OPERATOR: 'Opérateur de support',
  STORE_CLOCKING: 'Boutique pointage',
}

export const RIGHTS_KEYS = Object.keys(RIGHTS) as Right[]
